import script from "./ImportCourseHolesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportCourseHolesModal.vue?vue&type=script&setup=true&lang=js"

import "./ImportCourseHolesModal.vue?vue&type=style&index=0&id=206fa826&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-206fa826"]])

export default __exports__